import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { QueryClient, QueryClientProvider } from "react-query";

window.history.scrollRestoration = "manual";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: { refetchOnWindowFocus: false, staleTime: 300000 },
	},
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<QueryClientProvider client={queryClient}>
		<React.StrictMode>
			<App />
		</React.StrictMode>
	</QueryClientProvider>
);

const script = document.createElement("script");
script.setAttribute(
	"src",
	`https://www.google.com/recaptcha/enterprise.js?render=${process.env.REACT_APP_CAPTCHA_KEY}`
);
document.head.appendChild(script);
